import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { space } from 'styled-system';

import Icon from 'common/components/Icon';

const ICON_SIZE = 18;

const UnstyledArrow = styled(Icon)<any>`
  transform: rotate(${({ reversed }) => (reversed ? 180 : 0)}deg);
  ${space};
`;

const Arrow = (props: ComponentProps<typeof UnstyledArrow>) => (
  <UnstyledArrow name="arrowLeft" mx="sp_4" size={ICON_SIZE} {...props} />
);

export default Arrow;
